import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Notebook20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M4.75 1.75H11.2222V0.25H4.54167C3.7945 0.25 3.25 0.927092 3.25 1.64286V4.25H1V5.75H3.25V9.25H1V10.75H3.25V14.25H1V15.75H3.25V18.3571C3.25 19.0729 3.7945 19.75 4.54167 19.75H16.4583C17.2055 19.75 17.75 19.0729 17.75 18.3571V10H16.25V18.25H4.75V15.75H6V14.25H4.75V10.75H6V9.25H4.75V5.75H6V4.25H4.75V1.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.5982 1.2518C16.11 0.763642 15.3186 0.763643 14.8304 1.2518L9.30913 6.7731L8.62386 10.1995C8.48391 10.8992 9.10083 11.5161 9.80055 11.3762L13.2269 10.6909L18.7482 5.1696C19.2364 4.68145 19.2364 3.88999 18.7482 3.40183L16.5982 1.2518ZM10.6909 7.51262L15.7143 2.48923L17.5108 4.28572L12.4874 9.3091L10.2418 9.75822L10.6909 7.51262Z'
      fill='currentColor'
    />
  </Svg>
);

Notebook20.displayName = 'Notebook20';
export default Notebook20;
